<template>
    <div id="manage-attendance-page">
        <!-- HEADER -->
        <div class="action-header d-flex-wrap mb-3">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="this.$vuetify.lang.t('$vuetify.statusAttendance.searchByEmployeeNameOrID')"
                        solo dense hide-details
                        height="40px"
                        @keyup.enter="searchAttendances()">
                    </v-text-field>
                    <div class="ml-3">
                        <v-btn
                            height="40px"
                            color="primary"
                            outlined
                            @click="searchAttendances()">
                            {{ $vuetify.lang.t('$vuetify.statusAttendance.search') }}
                        </v-btn>
                    </div>
                </div>
            </div>
            <div class="d-flex">
                <!-- DEPRECATED: move to punch log tab -->
                <!-- <v-btn
                    class="mr-3 btn-text-color"
                    height="50"
                    width="170"
                    @click="genTextFile()"
                    color="#d76436">
                    {{ $vuetify.lang.t('$vuetify.statusAttendance.exportTXT') }}
                </v-btn> -->
                <v-btn
                    class="mr-3 btn-text-color"
                    height="50"
                    width="170"
                    @click="genPdfReport()"
                    color="#ff544a">
                    {{ $vuetify.lang.t('$vuetify.statusAttendance.exportPDF') }}
                </v-btn>
                <v-btn
                    class="btn-text-color"
                    height="50"
                    width="170"
                    @click="genExcelReport()"
                    color="#139888">
                    {{ $vuetify.lang.t('$vuetify.statusAttendance.exportExcel') }}
                </v-btn>
            </div>
        </div>
        <div class="action-header">
            <div class="d-flex-wrap">
                <date-picker-range
                    class="mr-3 date-range-input"
                    v-model="dateRange" />
                <div class="mr-3 select-filter">
                    <v-select
                        @change="searchAttendances()"
                        v-model="statusFilter"
                        :items="statusList"
                        item-text="text"
                        item-value="value"
                        outlined dense
                        height="40"
                        background-color="#ffffff">
                    </v-select>
                </div>
                <div class="mr-3 select-filter">
                    <v-select
                        @change="searchAttendances()"
                        v-model="bureauFilter"
                        :items="bureauList"
                        item-text="text"
                        item-value="value"
                        outlined dense
                        height="40"
                        background-color="#ffffff">
                    </v-select>
                </div>
                <div class="select-filter">
                    <v-select
                        @change="searchAttendances()"
                        v-model="locationFilter"
                        :items="locationList"
                        item-text="text"
                        item-value="value"
                        outlined
                        dense
                        height="40"
                        background-color="#ffffff">
                    </v-select>
                </div>
            </div>
        </div>
        <!-- END HEADER -->

        <!-- DATATABLE -->
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @click:row="attendanceInfo"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalData"
                :items="items"
                :empty-wrapper="false"
                :loading="loading">
            </v-data-table>
        </v-card>
        <!-- END DATATABLE -->

        <!-- PAGINATION -->
        <div
            v-if="pageCount"
            class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>
        <!-- END PAGINATION -->
    </div>
</template>

<script>
import DatePickerRange from '@/components/DatePickerRange.vue'

export default {
    name: 'ManageAttendance',

    components: {
        DatePickerRange
    },

    data () {
        return {
            loading: false,
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            items: [],
            totalData: 0,
            dateRange: [this.$dateUtil.getCurrentDate(), this.$dateUtil.getCurrentDate()],
            bureauFilter: null,
            statusFilter: null,
            locationFilter: null,
            bureauList: [],
            statusList: [],
            locationList: []
        }
    },

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.statusAttendance.employeeId'), value: 'employeeId', width: '10%' },
                { text: this.$vuetify.lang.t('$vuetify.statusAttendance.employeeName'), value: 'fullname', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.statusAttendance.bureau'), value: 'bureau', width: '12%' },
                { text: this.$vuetify.lang.t('$vuetify.statusAttendance.date'), value: 'date', width: '8%' },
                { text: this.$vuetify.lang.t('$vuetify.statusAttendance.locationIn'), value: 'checkinLocation', width: '10%' },
                { text: this.$vuetify.lang.t('$vuetify.statusAttendance.checkinTime'), value: 'checkin_at', width: '8%' },
                { text: this.$vuetify.lang.t('$vuetify.statusAttendance.locationOut'), value: 'checkoutLocation', width: '10%' },
                { text: this.$vuetify.lang.t('$vuetify.statusAttendance.checkoutTime'), value: 'checkout_at', width: '8%' },
                { text: this.$vuetify.lang.t('$vuetify.statusAttendance.totalHour'), value: 'workhours', width: '8%' },
                { text: this.$vuetify.lang.t('$vuetify.statusAttendance.status'), value: 'status', width: '8%' }
            ]
        }
    },

    methods: {
        async initAttendance () {
            await this.getBureaus()
            await this.getStatus()
            await this.getLocations()
            await this.getAttendances()
        },

        async searchAttendances () {
            this.options.page = 1
            await this.getAttendances()
        },
        async getAttendances () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `attendances?page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            if (this.dateRange.length > 0) {
                url += `&dateRange=${JSON.stringify(this.dateRange)}`
            }

            if (this.statusFilter) {
                url += `&status=${this.statusFilter}`
            }

            if (this.bureauFilter) {
                url += `&bureau=${this.bureauFilter}`
            }

            if (this.locationFilter) {
                url += `&location=${this.locationFilter}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.items = res.data.data
                this.totalData = res.data.total
            }
            this.loading = false
        },

        async getBureaus () {
            const res = await this.axios.get('bureau/options')
            if (res && res.data && res.data.status === 'ok') {
                this.bureauList = res.data.data
            }
        },

        async getStatus () {
            const res = await this.axios.get('attendance/status/options')
            if (res && res.data && res.data.status === 'ok') {
                this.statusList = res.data.data
            }
        },

        async getLocations () {
            const res = await this.axios.get('punchlog/location/options')
            if (res && res.data && res.data.status === 'ok') {
                this.locationList = res.data.data
            }
        },

        attendanceInfo (item) {
            this.$router.push({ name: 'StatusAttendanceForm', params: { id: item.id } })
        },

        // DEPRECATED: move to punch log tab
        // async genTextFile () {
        //     await this.$store.dispatch('setLoading', true)
        //     const response = await this.axios.post(
        //         'attendance/export/text',
        //         { search: this.search, dateRange: this.dateRange, bureau: this.bureauFilter, status: this.statusFilter, location: this.locationFilter },
        //         {
        //             headers: { 'Content-Type': 'text/plain; charset=utf-8' },
        //             responseType: 'blob'
        //         })

        //     if (response && response.data) {
        //         const timestamp = Date.now()
        //         this.$utils.saveLocalFile(`export-attendance-${timestamp}.txt`, response.data)
        //     } else {
        //         await this.$store.dispatch('setErrorModalShow', true)
        //         await this.$store.dispatch('setErrorModalMsg', this.$vuetify.lang.t('$vuetify.statusAttendance.somethingWrong'))
        //     }
        //     await this.$store.dispatch('setLoading', false)
        // },

        async genPdfReport () {
            const form = {
                search: this.search,
                dateRange: this.dateRange,
                bureau: this.bureauFilter,
                status: this.statusFilter,
                location: this.locationFilter
            }

            localStorage.formData = JSON.stringify(form)
            const routeData = this.$router.resolve({ name: 'ReportTimeAttendancePDF' })
            window.open(routeData.href)
        },

        async genExcelReport () {
            await this.$store.dispatch('setLoading', true)
            const response = await this.axios.post(
                'attendance/export/excel',
                {
                    search: this.search, dateRange: this.dateRange, bureau: this.bureauFilter, status: this.statusFilter, location: this.locationFilter
                }, {
                    headers: { 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
                    responseType: 'arraybuffer'
                })

            if (response && response.data) {
                const dateString = this.$dateUtil.getCurrentDate()
                this.$utils.downloadExcelFile(response.data, `time-attendance-report-${dateString}.xlsx`)
            } else {
                await this.$store.dispatch('setErrorModalShow', true)
                await this.$store.dispatch('setErrorModalMsg', this.$vuetify.lang.t('$vuetify.punchLog.somethingWrong'))
            }
            await this.$store.dispatch('setLoading', false)
        }
    },

    watch: {
        options: {
            async handler () {
                await this.initAttendance()
            }
        },
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                await this.initAttendance()
            },
            deep: true
        },
        dateRange () {
            if (this.dateRange.length === 0 || this.dateRange.length === 2) {
                this.searchAttendances()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .search-container {
        ::v-deep .v-input__control > .v-input__slot {
            min-height: auto !important;
            display: flex !important;
            align-items: center !important;
            box-shadow: none !important;
            border: 1px solid #a8a8a8 !important;
            width: 280px;
        }

        ::v-deep .search-input {
            align-items: center;
            .v-input__control > .v-input__slot {
                width: 340px;
            }
        }
    }

    ::v-deep .date-range-input .v-input__control > .v-input__slot {
        width: 220px;
    }

    ::v-deep .select-filter {
        .v-input__control > .v-input__slot {
            border: none !important;
            width: 200px;
        }

        .v-select__selection{
            line-height: 1.75;
        }
    }

    ::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
        margin: 0 !important;
    }

    ::v-deep .theme--light.v-data-table tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
        background: #eeeeee;
        cursor: pointer;
    }

    .btn-text-color {
        color: #ffffff;
    }

    .d-flex-wrap {
        display: flex;
        flex-wrap: wrap;
    }

    ::v-deep div[class*="select-filter"] .v-select__selection {
        line-height: 1.75;
    }

    @media only screen and (max-width: 1440px) {
        ::v-deep .search-input {
            .v-input__control > .v-input__slot {
                width: 330px !important;
            }
        }
    }
</style>
